import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { NotifactionService } from './core/services/notification.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Default,
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('npr-admin');
  private notificationService = inject(NotifactionService);

  // ngOnInit() {
  //   setTimeout(() => {
  //     this.notificationService.success('Test', 'The toast component is working!', 'Success');
  //   }, 1000);
  // }
}
